import api from 'Application/api/api';

const getTopics = (load = [], cancelToken = null) =>
    api.get('project-manager/topics', {
        params: { load },
        cancelToken,
    });

export default getTopics;
